import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CityResponse } from "@sportyano/core/models/cities/cities.model";
import { CountriesResponse } from "@sportyano/core/models/countries/countries.model";
import { Country } from "@sportyano/core/models/generals/country.model";
import { PlayerProfileFieldResponse } from "@sportyano/core/models/sports-human/sports-human.model";
import { SportResponse } from "@sportyano/core/models/sports/sports.model";
import {
	BehaviorSubject,
	catchError,
	map,
	Observable,
	of,
	shareReplay,
	tap,
} from "rxjs";
import { environment } from "src/environments/environment";
import {
	UserType,
	permission,
} from "@sportyano/core/models/permissions/permission";
import { CommonService } from "@sportyano/core/services/shard/common.service";
import { profileParams } from "@sportyano/core/models/account/profile";
import { AuthService } from "@sportyano/core/services/authServices/auth.service";
import { SpecializationResponse } from "@sportyano/core/models/Specialization/Specialization.model";

export type CropperDialogResult = {
	blob: Blob;
	imageUrl: string;
};

@Injectable({
	providedIn: "root",
})
export class GeneralService {
	private croppedImageState = new BehaviorSubject<CropperDialogResult | null>(null);

	private countries: CountriesResponse;
	private sports: SportResponse;
	private sportsOnlyUse:SportResponse
	private cities: CityResponse;
	private sportOptions: PlayerProfileFieldResponse;
	private countryId: number = 0;
	private sportId: number = 0;
	private sports$: Observable<SportResponse>;
	private Specializations$: Observable<SpecializationResponse>;
	private Specializations: SpecializationResponse;
	userType: permission;

	constructor(private http: HttpClient,private commonServices: CommonService,private auth:AuthService) {}

	getSportsHumen(sports_Id: number): Observable<PlayerProfileFieldResponse> {
		if (this.sportId == sports_Id) {
			return of(this.sportOptions);
		} else {
			return this.http
				.get<PlayerProfileFieldResponse>(
					// update here 30-5 ahmed omar
					`${environment.baseUrl}sports-property/`
				)
				.pipe(
					tap((sportOptions) => {
						this.sportOptions = sportOptions;
						this.sportId = sports_Id;
					})
				);
		}
	}

	fetchVideos(filter: any): Observable<any> {
		let params = new HttpParams()
			.set("sort_direction", filter.sort_direction)
			.set("contract", filter.contract.toString())
			.set("country_id", filter.country_id)
			.set("sport_id", filter.sport_id);

		if (filter.sport_option_position_id) {
			params = params.set(
				"sport_option_position_id",
				filter.sport_option_position_id
			);
			// Remove age_from and age_to if sport_option_position_id is present
		} else {
			params = params
				.set("age_from", filter.age_from)
				.set("age_to", filter.age_to);
		}

		return this.http.get(`${environment.baseUrl}players/videos`, {
			params,
		});
	}

	getSportsPositions(sports_Id: number): Observable<any> {
		if (this.sportId === sports_Id) {
			return of(this.sportOptions);
		} else {
			return this.http
				.get<any>(`${environment.baseUrl}sports/${sports_Id}/positions`)
				.pipe(
					map((response) => response.records),
					tap((sportOptions) => {
						this.sportOptions = sportOptions;
						this.sportId = sports_Id;
					})
				);
		}
	}

	getSports(): Observable<SportResponse> {
		if (!this.sports$) {
			this.sports$ = this.http
				.get<SportResponse>(`${environment.baseUrl}sports`)
				.pipe(
					tap((sports) => {
						this.sports = sports;
					}),
					shareReplay(1), // Share the observable and replay the last emitted value to new subscribers
					catchError((error) => {
						// Handle the error accordingly, for example, return an empty result
						return of();
					})
				);
		}

		return this.sports$;
	}
	getSpecializations(): Observable<SpecializationResponse> {
		if (!this.Specializations$) {
			this.Specializations$ = this.http
				.get<SpecializationResponse>(`${environment.baseUrl}specialisations`)
				.pipe(
					tap((Specializations) => {
						this.Specializations = Specializations;
					}),
					shareReplay(1), // Share the observable and replay the last emitted value to new subscribers
					catchError((error) => {
						// Handle the error accordingly, for example, return an empty result
						return of();
					})
				);
		}

		return this.Specializations$;
	}
	// get sports only selected in any module
	public sportsOnlyUsed(type:profileParams):Observable<SportResponse>{
		return this.http.get<SportResponse>(`${environment.baseUrl}sports/${type}`);
	}



	//delete programme
	deletePrograme(id: number, userType: string | null): Observable<void> {
		if (userType === "playground") {
			return this.http.delete<void>(
				`${environment.baseUrl}playgrounds/grounds/${id}`
			);
		} else if (userType === "academy") {
			return this.http.delete<void>(
				`${environment.baseUrl}academies/programs/${id}`
			);
		}  else if (userType === "federation") {
			return this.http.delete<void>(
				`${environment.baseUrl}federations/programs/${id}`
			);
		}

		else if (userType === permission.branch) {
			return this.http.delete<void>(
				`${environment.baseUrl}branch-user/programs/${id}`
			);
		}else {
			throw new Error("Invalid user type");
		}
	}
	deleteProgramePending(id: number, userType: string | null): Observable<void> {
		if (userType === "playground") {
			return this.http.delete<void>(
				`${environment.baseUrl}pending-grounds/${id}`
			);
		} else if (userType === "academy") {
			return this.http.delete<void>(
				`${environment.baseUrl}pending-programs/${id}`
			);
		}
		else if (userType === permission.branch) {
			return this.http.delete<void>(
				`${environment.baseUrl}branch-user/pending-programs/${id}`
			);
		}
		else if (userType === "federation") {
			return this.http.delete<void>(
				`${environment.baseUrl}pending-federation-programs/${id}`
			);
		}
		else {
			throw new Error("Invalid user type");
		}
	}

	getCountries(): Observable<CountriesResponse> {
		if (this.countries) {
			return of(this.countries);
		} else {
			return this.http
				.get<CountriesResponse>(`${environment.baseUrl}countries`)
				.pipe(tap((countries) => (this.countries = countries)));
		}
	}
// GET countries that have academies/playgrounds/players in them
	public getCountriesFilled(typeOfUser: string): Observable<any> {
		return this.http.get<any>(`${environment.baseUrl}countries/${typeOfUser}`).pipe(
			catchError((error) => {
				return this.getCountries();
			})
		);
	}

	getAcademyList(): Observable<any> {
		return this.http.get(`${environment.baseUrl}academies/all-academies`);
	}
	getFederationList(): Observable<any> {
		return this.http.get(`${environment.baseUrl}federations/all-federations`);
	}
	getCafesList(): Observable<any> {
		return this.http.get(`${environment.baseUrl}cafes`);
	}
	getAcademyListwithParam(params: any): Observable<any> {
		return this.commonServices.CommonGetWithParamRequests(`${environment.baseUrl}academies/all-academies`,params);
	}

	getCities(countryId: number): Observable<CityResponse> {
		if (!countryId) {
			this.cities = {
				success:true,
				records:[]
			}; // Set cities to empty if no countryId is provided
			return of(this.cities);
		}
		let params = new HttpParams().set("country_id", countryId);
		return this.http
			.get<CityResponse>(`${environment.baseUrl}cities`, {
				params: params,
			})
			.pipe(
				tap((cities) => {
					this.cities = cities;
					this.countryId = countryId;
				})
			);
	}

	// Get sub-cities/towns for a specific governorate
	getTowns(parentId: number): Observable<CityResponse> {
		return this.http.get<CityResponse>(`${environment.baseUrl}towns/${parentId}`);
	}

	getCitiesFilled(countryId: number,typeOfUser:string|null): Observable<CityResponse> {
		let params = new HttpParams().set("country_id", countryId);
		return this.http
			.get<CityResponse>(`${environment.baseUrl}cities/${typeOfUser}`, {
				params: params,
			})
			.pipe(
				tap((cities) => {
					this.cities = cities;
					this.countryId = countryId;
				})
			);
	}

	setCroppedImageState(value: CropperDialogResult | null) {
		if (value != null) {
			this.croppedImageState.next(value);
		}
	}

	getCroppedImageState() {
		return this.croppedImageState.asObservable();
	}

	clearCroppedImageState() {
		this.croppedImageState.next(null);
	}

	getCountryById(id: number): Country | undefined {
		return this.countries?.records.find((country) => country.id === id);
	}
}
